import {
  Activity,
  ArrowRight,
  Ban,
  Banknote,
  Building2,
  Calendar,
  Coins,
  ChartColumn,
  ChevronLeft,
  ChevronRight,
  Check,
  ChevronDown,
  CircleHelp,
  Clock,
  Copy,
  Download,
  Eye,
  FileText,
  Globe,
  Home,
  Inbox,
  Info,
  KeyRound,
  Layers,
  Link2,
  LogIn,
  LogOut,
  Mail,
  MessageCircle,
  MoreHorizontal,
  Moon,
  Plus,
  RefreshCw,
  Save,
  Server,
  Settings,
  Shield,
  Sparkles,
  Sun,
  Trash2,
  TriangleAlert,
  Undo2,
  Users,
  X,
  type LucideIcon,
} from 'lucide-react';

export type IconName =
  | 'globe'
  | 'chart'
  | 'users'
  | 'shield'
  | 'server'
  | 'layers'
  | 'pulse'
  | 'logout'
  | 'inbox'
  | 'alert'
  | 'chat'
  | 'more'
  | 'mail'
  | 'arrow'
  | 'home'
  | 'building'
  | 'key'
  | 'plus'
  | 'refresh'
  | 'trash'
  | 'check'
  | 'file'
  | 'help'
  | 'info'
  | 'link'
  | 'settings'
  | 'sparkles'
  | 'x'
  | 'eye'
  | 'save'
  | 'download'
  | 'login'
  | 'copy'
  | 'ban'
  | 'banknote'
  | 'coins'
  | 'undo'
  | 'chevron'
  | 'chevron-left'
  | 'chevron-right'
  | 'calendar'
  | 'clock'
  | 'moon'
  | 'sun';

const ICONS: Record<IconName, LucideIcon> = {
  globe: Globe,
  chart: ChartColumn,
  users: Users,
  shield: Shield,
  server: Server,
  layers: Layers,
  pulse: Activity,
  logout: LogOut,
  inbox: Inbox,
  alert: TriangleAlert,
  chat: MessageCircle,
  more: MoreHorizontal,
  mail: Mail,
  arrow: ArrowRight,
  home: Home,
  building: Building2,
  key: KeyRound,
  plus: Plus,
  refresh: RefreshCw,
  trash: Trash2,
  check: Check,
  file: FileText,
  help: CircleHelp,
  info: Info,
  link: Link2,
  settings: Settings,
  sparkles: Sparkles,
  x: X,
  eye: Eye,
  save: Save,
  download: Download,
  login: LogIn,
  copy: Copy,
  ban: Ban,
  banknote: Banknote,
  coins: Coins,
  undo: Undo2,
  chevron: ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  calendar: Calendar,
  clock: Clock,
  moon: Moon,
  sun: Sun,
};

export function Icon(props: { name: IconName; className?: string | undefined }) {
  const Glyph = ICONS[props.name] ?? CircleHelp;
  return <Glyph aria-hidden="true" className={props.className ?? 'size-5'} strokeWidth={1.75} />;
}
